// Must match the server enum
export enum CommitmentsEnabled {
  No = 0,
  Yes = 1
}

